module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Justus Streller, Wade Baskin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Justus Streller is the author of "), _c('I', [_vm._v("Jean-Paul Sartre: To Freedom Condemned")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BhbLo3/images/MyCoverImage.jpg?1733151179105",
      "alt": "This image is the cover for the book Jean-Paul Sartre: To Freedom Condemned"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jean-Paul Sartre: To Freedom Condemned\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("J"), _c('b', [_vm._v("ean-Paul Sartre’s most influential existentialist work, "), _c('i', [_vm._v("Being and Nothingness")])]), _c('b', [_vm._v(", broken down into its most fertile ideas "), _c('br')]), _vm._v("In "), _c('i', [_vm._v("To Freedom Condemned")]), _vm._v(", Sartre’s most influential work, "), _c('i', [_vm._v("Being and Nothingness")]), _vm._v(", is laid bare, presenting the philosopher’s key ideas regarding existentialism. Covering the philosophers Hegel, Heidegger, and Husserl, and mulling over such topics as love, God, death, and freedom, "), _c('i', [_vm._v("To Freedom Condemned")]), _vm._v(" goes on to consider Sartre’s treatment of the complexities around human existence.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0